<template>
  <div id="ListRegisterRequests">
    <loading v-if="loadingRender"></loading>
    <panel Title="گزارش درخواست های عضویت" Des="از طریق این فرم می توانید لیست درخواست های عضویت را مشاهده نمایید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <div class="col-12">
        <vue-bootstrap4-table v-if="$store.state.renderComponentGrid" :rows="rows" :columns="columns" :config="config" :classes="classes">
          <template slot="sort-asc-icon">
            <i class="fa fa-sort-up"></i>
          </template>
          <template slot="sort-desc-icon">
            <i class="fa fa-sort-down"></i>
          </template>
          <template slot="no-sort-icon">
            <i class="fa fa-sort"></i>
          </template>
          <template slot="empty-results">
            <p class="text-right">اطلاعاتی یافت نشد</p>
          </template>
          <template slot="Action" slot-scope="props">
            <div class="dropdown text-right">
              <button class="btn btn-outline-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-filter"></i> مشاهده پیوست ها</button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a
                  class="dropdown-item"
                  href="Javascript:;"
                  @click="
                    GetItemCardMeli(props.row.id)
                    $ResetTimer()
                  "
                  >تصویر روی کارت ملی</a
                >
                <a
                  class="dropdown-item"
                  href="Javascript:;"
                  @click="
                    GetItemShenasname(props.row.id)
                    $ResetTimer()
                  "
                  >صفحه اول شناسنامه</a
                >
                <a
                  class="dropdown-item"
                  href="Javascript:;"
                  @click="
                    GetItemHokm(props.row.id)
                    $ResetTimer()
                  "
                  >حکم کارگزینی/مستمری/بازماندگی</a
                >
                <a
                  class="dropdown-item"
                  href="Javascript:;"
                  @click="
                    Get3File(props.row.id)
                    $ResetTimer()
                  "
                  >دانلود هر سه فایل (ZIP)</a
                >
              </div>
              <button class="btn btn-warning m-1" type="button" @click="openModal(props.row.id)" data-toggle="modal" data-target="#Modal-ListRequset"><span>نیاز به اصلاح</span></button>
              <button class="btn btn-success m-1" type="button" @click="okState(props)"><span>تایید شد</span></button>
              <button
                class="btn btn-outline-dark m-1"
                type="button"
                v-if="props.row.stateId == 181070525"
                @click="
                  GetFish(props.row.id)
                  $ResetTimer()
                "
              >
                <span>دانلود فیش</span>
              </button>
              <button type="button" class="btn btn-danger" title="حذف درخواست" @click="removeRequest(props)"><i class="fa fa-trash"></i></button>
            </div>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>

    <div class="btn Pointer btn-outline-info d-none" @click="openModal" data-toggle="modal" data-target="#Modal-ListRequset">
      <i class="fas fa-list ml-2"></i>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="Modal-ListRequset" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="Modal-ListRequsetLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-info">
            <h5 class="modal-title text-dark" id="Modal-ListRequsetLabel">شرح اصلاح</h5>
          </div>
          <div class="modal-body text-right">
            <div class="row px-3">
              <div class="col-12 col-md-12 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-12 text-right">
                      <span class="text-secondary">شرح اصلاحات : </span>
                      <textarea type="text" class="form-control text-center" dir="rtl" v-model="DesState"></textarea>
                    </div>
                    <div class="col-12 mt-1 text-center">
                      <button @click="edtitState(rowIdSelected)" class="btn NetPa-btn btn-primary">ثبت تغییرات</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="$router.go(-1)" class="btn btn-secondary" data-dismiss="modal">انصراف</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Panel from '../Tools/NetPa/Panel.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'

export default {
  data() {
    return {
      rowIdSelected: 0,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'SelEftetahHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نام و نام خانوادگی',
          name: 'nameFamily',
        },
        {
          label: 'کد ملی',
          name: 'codeMeli',
        },
        {
          label: 'شماره پرسنلی',
          name: 'perNo',
        },
        {
          label: 'نام پدر ',
          name: 'pedar',
        },
        {
          label: 'شماره همراه ',
          name: 'mobile',
        },
        {
          label: 'تاریخ درخواست',
          name: 'tarixOzv',
        },
        {
          label: 'وضعیت',
          name: 'grpName',
        },
        {
          label: 'StateId',
          name: 'stateId',
          visibility: false,
        },
        {
          label: 'توضیحات',
          name: 'desState',
        },
        {
          label: 'معرف',
          name: 'desMoaref',
        },
        {
          label: 'عملیات',
          name: 'Action',
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
      Files: [],
      DataAxios_ModirTaeed: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'NewtblAza/ModirTaeed',
        Token: '',
      },
      DataAxios_edtitState: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'NewtblAza/UpdateDesState',
        Token: '',
      },
      DesState: '',
    }
  },
  components: {
    Panel,
    VueBootstrap4Table,
    loading,
  },
  methods: {
    openModal(data) {
      $('#Modal-ListRequset').modal('show')
      this.rowIdSelected = data
    },
    closeModal() {
      $('#Modal-ListRequset').modal('hide')
    },
    CancelDelete() {},
    IsModirTaeed(node) {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('id', node.row.id)
      this.DataAxios_ModirTaeed.ArryfildValue = formData
      //#region ثبت عضو و تعهد
        var formdata = new FormData()
        formdata.append('id', node.row.id)
        formdata.append('noeId', Number(JSON.parse($cookies.get('NoeIdPishFarz'))))
        var DataAxios_AzaForEftetahHesab = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'AzaForEftetahHesab',
          Token: '',
        }
        this.$PostFormData(DataAxios_AzaForEftetahHesab).then((data) => {})
      //#endregion
      this.$PostFormData(this.DataAxios_ModirTaeed).then(() => {
        this.$mySweetDefaultTost('تایید موفق', ' تایید درخواست عضویت با موفقیت انجام شد', 'success', 4000)
        this.loadingRender = false
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
    },
    okState(item) {
      this.$SweetQustion('تایید درخواست عضویت', 'آیا از تایید درخواست عضویت اطمینان دارید؟', 'info', 'تایید', 'انصراف', item, this.IsModirTaeed, this.CancelDelete)
    },
    edtitState(rowIdSelected) {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('id', rowIdSelected)
      formData.append('DesState', this.DesState)
      this.DataAxios_edtitState.ArryfildValue = formData

      this.$PostFormData(this.DataAxios_edtitState).then(() => {
        this.$mySweetDefaultTost('اصلاح موفق', ' اصلاح درخواست عضویت با موفقیت انجام شد', 'success', 4000)

        this.loadingRender = false
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
          this.closeModal()
        })
      })
    },
    GetData() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
      this.DataAxiosRow.ArryfildValue = formData
      // console.log(this.DataAxiosRow.ArryfildValue);

      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (data.length) {
          let info
          let list = []
          if (data.length > 10) {
            this.config.pagination = true
          } else {
            this.config.pagination = false
          }
          for (let index = 0; index < data.length; index++) {
            info = data[index]
            list.push(info)
          }
          this.rows = list
          this.loadingRender = false
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'درخواست عضویت یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
          this.config.pagination = false
          this.rows = []
          this.loadingRender = false
        }
      })
    },
    GetItemCardMeli(data) {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: data,
          tableName: 'wwwNewtblAzaForEftetahHesab',
          grp328: 181070514,
        },
      }
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data
        if (result.data == null || result.data.length == 0) {
        } else {
          this.Files = result.data
          var fileLink = document.createElement('a')
          fileLink.download = this.Files[0].filename
          fileLink.href = 'data:application/octet-stream;base64,' + this.Files[0].binary
          document.body.appendChild(fileLink)
          fileLink.target = '_blank'
          fileLink.click()
        }
      })
    },
    GetItemShenasname(data) {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: data,
          tableName: 'wwwNewtblAzaForEftetahHesab',
          grp328: 181070505,
        },
      }
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data
        if (result.data == null || result.data.length == 0) {
        } else {
          this.Files = result.data
          var fileLink = document.createElement('a')
          fileLink.download = this.Files[0].filename
          fileLink.href = 'data:application/octet-stream;base64,' + this.Files[0].binary
          document.body.appendChild(fileLink)
          fileLink.target = '_blank'
          fileLink.click()
        }
      })
    },
    GetItemHokm(data) {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: data,
          tableName: 'wwwNewtblAzaForEftetahHesab',
          grp328: 181070516,
        },
      }
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data
        if (result.data == null || result.data.length == 0) {
        } else {
          this.Files = result.data
          var fileLink = document.createElement('a')
          fileLink.download = this.Files[0].filename
          fileLink.href = 'data:application/octet-stream;base64,' + this.Files[0].binary
          document.body.appendChild(fileLink)
          fileLink.target = '_blank'
          fileLink.click()
        }
      })
    },
    GetFish(data) {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: data,
          tableName: 'wwwNewtblAzaForEftetahHesab',
          grp328: 181070524,
        },
      }
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data
        if (result.data == null || result.data.length == 0) {
        } else {
          for (let index = 0; index < result.data.length; index++) {
            this.Files = result.data
            var fileLink = document.createElement('a')
            fileLink.download = this.Files[index].filename
            fileLink.href = 'data:application/octet-stream;base64,' + this.Files[index].binary
            document.body.appendChild(fileLink)
            fileLink.target = '_blank'
            fileLink.click()
          }
        }
      })
    },
    Get3File(data) {
      var dataAxios = {
        Method: 'POST',
        Action: 'Uploader/GetFile',
        ArryfildValue: {
          MasterId: data,
          tableName: 'wwwNewtblAzaForEftetahHesab',
          grp328: 181070517,
        },
      }
      this.$PostData(dataAxios).then((result) => {
        // console.log(result);
        this.file = result.data
        if (result.data == null || result.data.length == 0) {
        } else {
          for (let index = 0; index < result.data.length; index++) {
            this.Files = result.data
            var fileLink = document.createElement('a')
            fileLink.download = this.Files[index].filename
            fileLink.href = 'data:application/octet-stream;base64,' + this.Files[index].binary
            document.body.appendChild(fileLink)
            fileLink.target = '_blank'
            fileLink.click()
          }
        }
      })
    },
    removeRequest(row) {
      this.$SweetQustion('حذف درخواست عضویت', 'آیا از حذف درخواست عضویت ' + row.row.nameFamily + ' با شماره پرسنلی ' + row.row.perNo + ' اطمینان دارید؟ درصورت حذف اطلاعات به هیچ عنوان قابل بازگشت نمی باشد', 'warning', 'حذف', 'انصراف', row.row, this.acceptRemove, this.CancelDelete)
    },
    acceptRemove(row) {
      console.log(row)
      this.loadingRender = true
      const formData = new FormData()
      formData.append('id', row.id)
      let DataAxios_Remove = {
        ArryfildValue: formData,
        Method: 'Post',
        Action: 'InsNewAza/Delete',
        Token: this.$session.get('TokenNetPa'),
      }
      let icon = ''
      this.$PostFormData(DataAxios_Remove).then((res) => {
        console.log('🤦🏻‍♂️ ~ file: ListRegisterRequests.vue:455 ~ res:', res)
        this.loadingRender = false
        if (res.status == true) {
          this.GetData()
          icon = 'success'
        } else {
          icon = 'error'
        }
        this.$mySweetDefaultTost('حذف موفق', res.message, icon, 4000)
      })
    },
  },
  mounted() {
    this.GetData()
  },
}
</script>
<style scoped></style>
